import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { SEARCH_PERFORMANCE_ROUTE } from '../SearchPerformanceRoutes';
import GscConnectionWizard from './GscConnectionWizard';
import useGscConnectionFlow from './useGscConnectionFlow';

// The connect half of the route pair: a page in its own right, reachable at any
// moment (the Integrations Reconnect CTA and the OAuth same-tab fallback land here
// even with a live connection). It forwards to the dashboard on ONE condition —
// an in-session sync completion — and never for a bare/returning visit, so a
// param-lost reconnect is never bounced out. See `gsc-connection/AGENTS.md`.
function SearchPerformanceConnect() {
  const navigate = useNavigate();
  const flow = useGscConnectionFlow();

  // Only a customer who finished the picker this session (`selectedPropertyCount > 0`)
  // is forwarded, the moment their first sync lands. `replace` so Back does not
  // return into the now-empty sync step; the ref fires it once.
  const forwardedRef = useRef(false);
  useEffect(() => {
    if (!forwardedRef.current && flow.isSyncComplete && flow.selectedPropertyCount > 0) {
      forwardedRef.current = true;
      navigate(SEARCH_PERFORMANCE_ROUTE, { replace: true });
    }
  }, [flow.isSyncComplete, flow.selectedPropertyCount, navigate]);

  return (
    <GscConnectionWizard
      flow={flow}
      onDone={() => navigate(SEARCH_PERFORMANCE_ROUTE)}
    />
  );
}

export default SearchPerformanceConnect;
